import { render, staticRenderFns } from "./OnboardingEmployee.vue?vue&type=template&id=bfd0540a&scoped=true&"
import script from "./OnboardingEmployee.vue?vue&type=script&lang=js&"
export * from "./OnboardingEmployee.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingEmployee.vue?vue&type=style&index=0&id=bfd0540a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd0540a",
  null
  
)

export default component.exports